module.exports = __webpack_public_path__ + "assets/cbffe1d891a2017e082d6774c42050b2.mp4";